/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HchbPatientRequestSummary
 */
export interface HchbPatientRequestSummary {
    /**
     * 
     * @type {string}
     * @memberof HchbPatientRequestSummary
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientRequestSummary
     */
    lead_id: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientRequestSummary
     */
    status: HchbPatientRequestSummaryStatusEnum;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof HchbPatientRequestSummary
     */
    request_payload: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof HchbPatientRequestSummary
     */
    response_payload?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof HchbPatientRequestSummary
     */
    error_message?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientRequestSummary
     */
    created_at: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientRequestSummary
     */
    updated_at?: string;
}


/**
 * @export
 */
export const HchbPatientRequestSummaryStatusEnum = {
    Pending: 'pending',
    InProgress: 'in_progress',
    Completed: 'completed',
    Failed: 'failed'
} as const;
export type HchbPatientRequestSummaryStatusEnum = typeof HchbPatientRequestSummaryStatusEnum[keyof typeof HchbPatientRequestSummaryStatusEnum];


/**
 * Check if a given object implements the HchbPatientRequestSummary interface.
 */
export function instanceOfHchbPatientRequestSummary(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "lead_id" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "request_payload" in value;
    isInstance = isInstance && "created_at" in value;

    return isInstance;
}

export function HchbPatientRequestSummaryFromJSON(json: any): HchbPatientRequestSummary {
    return HchbPatientRequestSummaryFromJSONTyped(json, false);
}

export function HchbPatientRequestSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPatientRequestSummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'lead_id': json['lead_id'],
        'status': json['status'],
        'request_payload': json['request_payload'],
        'response_payload': !exists(json, 'response_payload') ? undefined : json['response_payload'],
        'error_message': !exists(json, 'error_message') ? undefined : json['error_message'],
        'created_at': json['created_at'],
        'updated_at': !exists(json, 'updated_at') ? undefined : json['updated_at'],
    };
}

export function HchbPatientRequestSummaryToJSON(value?: HchbPatientRequestSummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'lead_id': value.lead_id,
        'status': value.status,
        'request_payload': value.request_payload,
        'response_payload': value.response_payload,
        'error_message': value.error_message,
        'created_at': value.created_at,
        'updated_at': value.updated_at,
    };
}

